import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UIService } from 'src/app/services/ui.service';

@Component({
  selector: 'app-info',
  templateUrl: './info.page.html',
  styleUrls: ['./info.page.scss'],
})
export class InfoPage implements OnInit {

  constructor(private modalCtrl: ModalController,
    private ui: UIService,
    // private iab: InAppBrowser
  ) { }

  ngOnInit() {
  }

  decreto(tipo) {
    if (tipo === 1) {
      // const browser = this.iab.create('http://www2.admtransito.com.br/cvcp/assets/doc/268610-decretocaminhoes.html');
      this.ui.showRemoteFile('http://www2.admtransito.com.br/cvcp/assets/doc/268610-decretocaminhoes.html', 'text/html');
    }
    if (tipo === 2) {
      // const browser = this.iab.create('http://www2.admtransito.com.br/cvcp/assets/doc/268610-decretopedagio.html');
      //this.ui.showRemoteFile('http://www2.admtransito.com.br/cvcp/assets/doc/268610-decretopedagio.html', 'text/html');
      this.ui.showRemoteFile('http://www2.admtransito.com.br/cvcp/assets/doc/268610-leipedagio.pdf');
    }
  }

  sair() {
    this.modalCtrl.dismiss();
  }

}
